export default __webpack_public_path__ + "static/domain-tab-954d3a703764e8b182a7e669822ba9d0.png";